import { useEffect, useState } from 'react'
import { ImageOff } from 'lucide-react'

import { fetchFeedbackChatAttachment } from '@/services/feedback-chat-api'

type State = { status: 'loading' } | { status: 'ready'; url: string } | { status: 'error' }

/** Sohbet ekini kimlik başlığıyla çekip blob URL ile gösterir (ek adresi sayfaya sızmaz). */
export function ChatAttachmentImage({ id, className }: { id: string; className?: string }) {
  const [state, setState] = useState<State>({ status: 'loading' })

  useEffect(() => {
    let cancelled = false
    let objectUrl: string | null = null
    const controller = new AbortController()
    setState({ status: 'loading' })
    fetchFeedbackChatAttachment(id, controller.signal)
      .then((blob) => {
        if (cancelled) return
        objectUrl = URL.createObjectURL(blob)
        setState({ status: 'ready', url: objectUrl })
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' })
      })
    return () => {
      cancelled = true
      controller.abort()
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [id])

  if (state.status === 'error') {
    return (
      <p className="flex items-center gap-2 text-xs opacity-80">
        <ImageOff className="size-4" aria-hidden="true" />
        Görsel yüklenemedi
      </p>
    )
  }
  if (state.status === 'loading') {
    return <div role="status" aria-label="Görsel yükleniyor" className="h-28 w-48 animate-pulse rounded-lg bg-foreground/10 motion-reduce:animate-none" />
  }
  return (
    <img
      src={state.url}
      alt="Sohbete eklenen ekran görüntüsü"
      className={className ?? 'max-h-64 w-auto max-w-full rounded-lg border border-border/40 object-contain'}
    />
  )
}
